import * as requestToApi from "./MasterLayoutCRUD";
import { masterLayoutSlice } from "./MasterLayoutSlice";

const { actions } = masterLayoutSlice;

export const requestRemovePromoStep1 = (queryParams) => (dispatch) => {
  return requestToApi
    .postMember6(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          return response;
        }
      } else {
        throw new Error("Error api: requestRemovePromoStep1");
      }
    })
    .catch((error) => {
      throw error;
    });
};

export const requestRemovePromoStep2 = (queryParams) => (dispatch) => {
  return requestToApi
    .postMember6(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          return response;
        }
      } else {
        throw new Error("Error api: requestRemovePromoStep2");
      }
    })
    .catch((error) => {
      throw error;
    });
};

// export const getPromotionReviewInfo = (queryParams) => (dispatch) => {
//   dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));
//   return requestToApi
//     .fetchPromotionReviewInfo(queryParams)
//     .then((response) => {
//       if (response) {
//         if (!response.data.isAbort) {
//           dispatch(actions.promotionReviewInfoFetched({ data: response.data }));
//           return response;
//         }
//       } else {
//         throw new Error("Error api: fetchPromotionReviewInfo");
//       }
//     })
//     .catch((error) => {
//       dispatch(
//         actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
//       );
//       throw error;
//     });
// };
